import request from './request'
// import { useUserStore } from '@/store';

// const userStore = useUserStore();

// const addAccessToData = (data) => {
//     data['accessToken'] = '';
//     data['userId'] = '';

//     return data;
// };
const loginLink = '/services/member/product'

const loginModule = {
    
    /**
     * 登录操作
     * @param {*} data 
     * @param {*} headers 
     * @returns 
     */
    pwdLogin(data, headers){
        return request({
            url: loginLink + '/doLoginByPhone',
            method: 'post',
            data,
            headers
        })
    },

    // 发送短信登录验证码
    sendSmsVerifyCode(data, headers) {
        return request({
            url: loginLink + '/sendSmsVerifyCode',
            method: 'post',
            data,
            headers
        })
    },

    // 短信验证码登录
    doLoginByVerifyCode(data, headers) {
        return request({
            url: loginLink + '/doLoginByVerifyCode',
            method: 'post',
            data,
            headers
        })
    },

    // 获取用户信息
    getUserInfoEncryption(data, headers) {
        return request({
            url: loginLink + '/getUserInfoEncryption',
            method: 'post',
            data,
            headers,
            access: true
        })
    },

    // 获取是否默认用户
    checkDefaultUser() {
        return request({
            url: loginLink + '/checkDefaultUser',
            method: 'post',
            data: {},
            access: true
        })
    },

    
    // 修改用户密码
    changePassword(pwdHash) {
        return request({
            url: loginLink + '/changePassword',
            method: 'post',
            data: {
                newPwd: pwdHash
            },
            access: true
        })
    },

    // 校验手机验证码
    checkVerifyCode(data) {
        return request({
            url: loginLink + '/checkSmsVerifyCode',
            method: 'post',
            data: data
        })
    },

    // 手机号验证码注册
    doRegister(data) {
        return request({
            url: loginLink + '/doRegisterByPhone',
            method: 'post',
            data: data
        })
    },

    // 更改密码
    changeForgetPassword (data) {
        return request({
            url: loginLink + '/forgetPassword',
            method: 'post',
            data: data
        })
    },

    // 填写用户注册信息(验证码登录调用设置密码)
    userSetPwd(data) {
        return request({
            url: loginLink + '/registerUserInfo',
            method: 'post',
            data: data,
            access: true
        })
    }

}

export default loginModule